import React, { useState, useCallback } from 'react';

interface IErrorContext {
    error: string | null,
    addError: (error?: string) => void,
    removeError: () => void
};

const context: IErrorContext = {
    error: null,
    addError: (error?: string) => {},
    removeError: () => {}
}

export const ErrorContext = React.createContext(context);

const ErrorProvider: React.FC<{}> = ({ children }) => {
  const [error, setError] = useState<string | null>(null);

  const removeError = () => setError(null);

  const addError = (error?: string) => setError(error || "Произошла ошибка! Попробуйте ещё раз.");

  const contextValue: IErrorContext = {
    error,
    addError: useCallback((error?: string) => addError(error), []),
    removeError: useCallback(() => removeError(), [])
  };

  return (
    <ErrorContext.Provider value={contextValue}>
      {children}
    </ErrorContext.Provider>
  );
};

export default ErrorProvider;